import { log } from '@hotjar/insights-common/lib/log';
import { getAccessTokenHeaders, checkAndReloadAccessToken } from '@hotjar/auth';

angular.module('hjApp').service('DownloadBlob', function ($q) {
    this.open = async function (url, filename, isJWTActive = true) {
        const tokenResult = await checkAndReloadAccessToken();

        var deffered = $q.defer();
        var req = new XMLHttpRequest();
        req.open('GET', url, true);

        if (isJWTActive) {
            const accessTokenHeaders = getAccessTokenHeaders(tokenResult) ?? {};
            for (const headerKey in accessTokenHeaders) {
                req.setRequestHeader(headerKey, accessTokenHeaders[headerKey]);
            }
        }

        req.responseType = 'arraybuffer';
        req.onload = function () {
            // If we get json back instead then reject using the response so that we can handle.
            if (this.getResponseHeader('content-type') === 'application/json') {
                var bodyEncodedInString = String.fromCharCode.apply(String, new Uint8Array(req.response));
                deffered.reject(JSON.parse(bodyEncodedInString));
            } else {
                download(req.response, filename, 'octet/stream');
                deffered.resolve();
            }
        };
        req.send();
        return deffered.promise;
    };

    /**
     * Related to: BUG-40
     *
     * Stackoverflow credits: https://stackoverflow.com/a/52593293
     *
     * The following function was suggested as a 'partial' solution that
     * will enable clients to download larger files.
     *
     * Although this will get us in a better state, meaning that some
     * clients that were not able to download large files, now will be able
     * to do so, it is good to keep in mind that this solution cannot be
     * watertight enough. We are still bound to the client's hardware (we
     * don't know on which hardware this code is running on) and therefore
     * this functionality can break for whatever reason (lack of memory,
     * antivirus, browser incompatibilities) with us not knowing. Should we
     * see the benefit of spending more time on this feature, we could
     * consider moving this processing at the backend where we have full
     * control on the environment, and treat this as a simple HTTP request
     * that will download the screenshot.
     *
     * This service assumes the downlaod mime type of "image/octet-stream".
     *
     * @param {string} dataurl
     * @param {string} fileName
     *
     * @return {Blob}
     */
    this.fromDataURL = (dataurl, fileName) => {
        if (dataurl && fileName) {
            try {
                const arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]);
                let n = bstr.length;
                const u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                const blob = new Blob([u8arr], { type: mime });
                download(blob, fileName, 'image/octet-stream');
            } catch (e) {
                log.warn('Something went wrong downloading the heatmap image', e);
            }
        }
    };
});
